module.exports = {
	"articleTitle1": "Final Lap: After more than a century, Ferry Field's run to end next year",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Ferry Field",
	"articleLink2": "https://www.michigandaily.com/section/statement/branding-blue-athletics-academics-history-block-m",
	"articleSnippet1": "Apr 1, 2014 ... Few on it may know, but Ferry Field is no ordinary track. The orange synthetic \npolyurethane beneath their feet was once grass whose growth ...",
	"articleSnippet2": "Mar 28, 2017 ... In 1907, students attending a football game at Ferry Field — the predecessor to \nMichigan Stadium — first raised maize and blue flags to form ...",
	"totalMisc": 0,
	"articleTitle2": "Behind the Block 'M': The Business of Branding a University ",
	"address": "1150 S. State St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/tjm.RUN_.lenpaddock.5-4-12.00027.jpg",
			"author": "Terra Molengraff",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.268889,
		"lng": -83.742503
	},
	"tips": [],
	"articleLink1": "https://www.michigandaily.com/sports/final-lap-after-108-years-ferry-field%E2%80%99s-run-end-next-year",
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ferryfield.json
// module id = 877
// module chunks = 0